import React from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'

function BlogPostCard({ post, t }) {
  const { locale } = useLocale()
  const postPath = `${locale === 'fr' ? '/fr' : ''}/blog/${post.id}`
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  const getCategoryName = (categoryId) => {
    const category = t.blog[categoryId] || categoryId
    return category
  }

  return (
    <Link to={postPath}>
      <article className="blog-card">
        <div className="blog-card-image">
          <img 
            src={post.image} 
            alt={post.title}
            onError={(e) => {
              e.target.src = '/assets/blog/placeholder.jpg'
              e.target.alt = 'Blog post image'
            }}
          />
          <div className="blog-card-category">
            {getCategoryName(post.category)}
          </div>
        </div>
        
        <div className="blog-card-content">
          <div className="blog-card-meta">
            <span className="blog-card-date">
              {t.blog.publishedOn} {formatDate(post.date)}
            </span>
            <span className="blog-card-author">
              {t.blog.by} {post.author}
            </span>
          </div>
          
          <h3 className="blog-card-title">
            <Link to={postPath}>
              {post.title}
            </Link>
          </h3>
          
          <p className="blog-card-excerpt">
            {post.excerpt}
          </p>
          
          <div className="blog-card-footer">
            <span className="blog-card-read-time">
              {post.readTime}
            </span>
            <Link to={postPath} className="blog-card-link">
              {t.blog.readMore}
            </Link>
          </div>
        </div>
      </article>
    </Link>
  )
}

export default BlogPostCard
